import React, { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";
import DashboardCard from "./DashboardCard";
import EarningChart from "./EarningChart";
import "./Dashboard.css";

export default function Dashboard() {
  const [balance, setBalance] = useState(0);
  const [totalInvested, setTotalInvested] = useState(0);
  const [todaysProfit, setTodaysProfit] = useState(0);
  const [totalPayout, setTotalPayout] = useState(0);
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    loadUserStats();
  }, []);

  const loadUserStats = async () => {
    const { data: auth } = await supabase.auth.getUser();
    if (!auth?.user) return;

    setUserId(auth.user.id);

    const { data, error } = await supabase
      .from("users_data")
      .select("*")
      .eq("user_id", auth.user.id)
      .maybeSingle();


    if (error) {
      console.log("Load error:", error);
      return;
    }

    updateStates(data);
    subscribeRealtime(auth.user.id);
  };

  const updateStates = (data) => {
    setBalance(data.balance || 0);
    setTotalInvested(data.total_invested || 0);
    setTodaysProfit(data.todays_profit || 0);
    setTotalPayout(data.total_payout || 0);
  };

  // ---- REALTIME LISTENER ----
  const subscribeRealtime = (uid) => {
    supabase
      .channel("user_data_realtime")
      .on(
        "postgres_changes",
        {
          event: "*",
          schema: "public",
          table: "users_data",
          filter: `user_id=eq.${uid}`,
        },
        (payload) => {
          console.log("Realtime update:", payload.new);
          updateStates(payload.new);
        }
      )
      .subscribe();
  };

  return (
    <main className="dash-body">
      <div className="dash-inner">

        <div className="cards-row">

          <DashboardCard
            title="Total Balance"
            value={`$${Number(balance).toFixed(2)}`}
            variant="c1"
          />

          <DashboardCard
            title="Total Invested"
            value={`$${Number(totalInvested).toFixed(2)}`}
            variant="c2"
          />

          <DashboardCard
            title="Today's Profit"
            value={`$${Number(todaysProfit).toFixed(2)}`}
            variant="c3"
          />

          <DashboardCard
            title="Total Payout"
            value={`$${Number(totalPayout).toFixed(2)}`}
            variant="c4"
          />

        </div>

        <div className="chart-row">
          <EarningChart />
        </div>

      </div>
    </main>
  );
}
